module.exports = __webpack_public_path__ + "img/servicioVial.ccb20305.jpg";